import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getCategorizedFunds: () => ({
    url: 'Fund/Anonymous/api/v1/General/Funds',
    method: 'GET',
  }),
  getFunds: () => ({
    url: 'Fund/api/v2/Invest/FundAndEtfs',
    anonymousUrl: 'Fund/Anonymous/api/v1/General/FundAndEtfs',
    method: 'GET',
  }),
  getFundsAnonymous: () => ({
    url: 'Fund/Anonymous/api/v1/General/FundAndEtfs',
    method: 'GET',
  }),
  getFundDetail: (input) => ({
    url: 'Fund/Anonymous/api/v1/General/Fund/Detail',
    method: 'GET',
    params: input,
  }),
  getCategorizedETFs: () => ({
    url: 'Fund/Anonymous/api/v1/General/etfs',
    method: 'GET',
  }),
  getAssets: () => ({
    url: 'Fund/api/v1/Invest/Assets',
    method: 'GET',
  }),
  getChildAssets: (input) => ({
    url: 'fund/api/v1/user/childAssets',
    method: 'GET',
    params: input,
  }),
  getETFAssets: () => ({
    url: 'Fund/api/v1/Invest/Etfs/Assets',
    method: 'GET',
  }),
  getTransactions: (input) => ({
    url: 'Fund/api/v3/Invest/Funds/Transaction',
    method: 'GET',
    params: input,
  }),
  requestRedemption: (input) => ({
    url: `Fund/api/v1/Stocks/FundRedemption`,
    method: 'POST',
    data: input,
  }),
  cancelIssuance: (input) => ({
    url: `Fund/api/v1/Invest/Fund/Issuance`,
    method: 'DELETE',
    data: input,
  }),
  cancelRedemption: (input) => ({
    url: 'Fund/api/v1/Stocks/FundRemoveRedemption',
    method: 'POST',
    data: input,
  }),
  updateRedemption: (input) => ({
    url: 'Fund/api/v1/Stocks/FundUpdateRedemption',
    method: 'POST',
    data: input,
  }),
  requestConsultation: () => ({
    url: 'Fund/api/v1/Crm/Consultation',
    method: 'POST',
  }),
  getLastIndex: () => ({
    url: 'Fund/Anonymous/api/v1/General/LastIndex',
    method: 'GET',
  }),
  getHistory: (input) => ({
    url: 'Fund/Anonymous/api/v1/General/History',
    method: 'GET',
    params: input,
  }),
  getStockHistory: (input) => ({
    url: 'Trade/Anonymous/api/v1/General/History',
    method: 'GET',
    params: input,
  }),
  getAssetTrend: (input) => ({
    url: 'Fund/api/v1/Invest/Funds/Assets/Trend',
    method: 'POST',
    data: input,
  }),
  getTotalAssetTrend: (input) => ({
    url: 'Fund/api/v1/Invest/Funds/Assets/TrendTotal',
    method: 'POST',
    data: input,
  }),
  getMarketCapComparison: (input) => ({
    url: `Fund/Anonymous/api/v1/General/MarketCapComparison${
      input?.stockCode ? `?symbol=${input.stockCode}` : ''
    }`,
    method: 'GET',
    data: null,
  }),
  FundRedemption: (input) => ({
    url: 'Fund/api/v1/Stocks/FundRedemption',
    method: 'POST',
    data: input,
  }),
  getFundAdvisory: () => ({
    url: 'Fund/Anonymous/api/v1/General/Investmentspec',
    method: 'GET',
  }),
  getFundAdvisoryAllocation: (input) => ({
    url: `Fund/api/v1/Allocation/AmountCalculator?InvestmentSpecId=${input.InvestmentSpecId}&amount=${input.amount}`,
    method: 'GET',
    data: input,
  }),
  requestRoboAdvisoryConsultation: (input) => ({
    url: 'Fund/api/v1/InvestmentSpec/SendSms',
    method: 'POST',
    data: input,
  }),
  createAllocation: (input) => ({
    url: 'Fund/api/v1/Allocation/Create',
    method: 'POST',
    data: input,
  }),
  getFundInvestorBankInfo: () => ({
    url: 'Fund/api/v1/Stocks/FundInvestorBankInfo',
    method: 'GET',
  }),
  getFundHistoryRatio: (input) => ({
    url: 'Fund/Anonymous/api/v1/General/fundHistoryRatio',
    method: 'GET',
    params: input,
  }),
  getInvestmentAdvisoryPackage: () => ({
    url: 'Fund/api/v1/investmentSpec/inquiryUserPackages',
    method: 'GET',
  }),
};

export default apis;
